import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUserSettings from '../reducers/usersettings.reducer';

export const selectUserSettingsState = createFeatureSelector<fromUserSettings.State>(
  fromUserSettings.userSettingsFeatureKey
);

export const getSection = createSelector(selectUserSettingsState, state => state.section);

